<template>
  <div :class="['hoistingDetail_' + selfKey,'hoistingDetail new-multiselect']">
    <div class="hoistingDetail_operate">
      <template v-if="showOperate && !parentPermitEditable">
        <button
          v-if="!isEditing && showEditBtn"
          class="btn--darkblue"
          @click="changeEditStatus"
        >
          {{ $t('action.edit') }}
        </button>
        <button
          v-if="isEditing"
          class="btn--darkblue"
          @click="cancel"
        >
          {{ $t('action.cancel') }}
        </button>
        <button
          v-if="isEditing"
          class="btn--orange"
          @click="onSave()"
        >
          {{ $t('action.save') }}
        </button>
        <button
          v-if="isEditing"
          class="btn--orange"
          :disabled="isSubmitDisable"
          @click="submit"
        >
          {{ $t('action.submit') }}
        </button>
      </template>
      <button
        v-if="showPrint"
        class="btn--orange"
        @click="printHoisting"
      >
        {{ $t('workPermit.print') }}
      </button>
    </div>

    <template v-if="!isEditing && isWaitingApprove">
      <i class="gray_font">{{ $t('workPermit.waitingApproveBy', [personIncharge]) }}</i>
    </template>
    <i
      v-if="submitByInfo.who && submitByInfo.when"
      class="gray_font"
    >
      {{ $t('submittedByOn',[submitByInfo.who, submitByInfo.when]) }}
    </i>
    <div class="hoistingDetail_contractor">
      <p class="bold">
        {{ $t('workPermit.contractorName') }}
      </p>
      <span>{{ hoistingContractorInfo && hoistingContractorInfo.name || $t('emptyValue') }}</span>
    </div>
    <table :class="['hoistingDetail_table', {isEditing}]">
      <tr>
        <td class="hoistingDetail_building">
          <p :class="['bold']">
            {{ $t('workPermit.building') }}
          </p>
        </td>
        <td class="hoistingDetail_floor">
          <p :class="['bold', {'required-flag': isEditing}]">
            {{ $t('workPermit.floor') }}
          </p>
        </td>
      </tr>
      <tr>
        <td class="hoistingDetail_building">
          {{ buildingFullName | isEmptyValue }}
        </td>
        <td class="hoistingDetail_floor">
          <HKLSelect
            v-if="isEditing"
            class="small-6 medium-6 large-6 columns hoisting-floor-select"
            :class="{'error-highlight': !validFloor}"
            :value="floorVal || undefined"
            :options="floorHklOptions"
            :showSearch="true"
            placeholder=""
            @change="val => updateFloor(val)"
          />
          <span v-else>{{ getFloor() || $t('emptyValue') }}</span>
        </td>
      </tr>
    </table>
    <div class="hoistingDetail_workArea">
      <InputField
        :readonly="!isEditing"
        :showColon="false"
        :showFlag="isEditing"
        :label="isEdit ? $t('workPermit.workAreaWithIn') : $t('workPermit.workArea')"
        :value="hoistingData.workArea"
        :required="isEditing"
        :showEmptyDash="true"
        @updateValue="val => updateField('workArea', val)"
      />
    </div>
    <div class="hoistingDetail_description">
      <InputField
        :label="$t('workPermit.descriptionOfWork')"
        :readonly="!isEditing"
        :showColon="false"
        :placeholder="$t('workPermit.hoistingDescriptionWorkHint')"
        :showFlag="isEditing"
        :value="hoistingData.description"
        :required="isEditing"
        :showEmptyDash="true"
        @updateValue="val => updateField('description', val)"
      />
    </div>
    <div class="hoistingDetail_duration">
      <p :class="['bold', {'required-flag': isEditing}]">
        {{ durationTitleLabel }}
      </p>
      <div class="hoistingDetail_timePicker">
        <DateTimeSelector
          v-if="isEditing"
          :key="`duration-from-${timestamp}`"
          :timeOptions="timeOptions"
          :date="hoistingData.startDate"
          :showClearBtn="true"
          :setMinTime="true"
          :disabledDates="disabledFromDates"
          :highlightClass="!validStartDate ? 'error-highlight': ''"
          :required="isEditing"
          :dirtyCheck="true"
          @updateDate="onHoistingStartDateChange"
        />
        <span v-else>{{ formatDate(hoistingData.startDate, true) }}</span>
        <span
          v-if="isEditing"
          class="hoistingDetail_timePickerTo"
        >
          {{ $t('dateTo') }}
        </span>
        <span v-else>-</span>
        <DateTimeSelector
          v-if="isEditing"
          :key="`date-to-${timestamp}-${hoistingData.startDate || 'no-from'}`"
          :timeOptions="timeOptions"
          :date="hoistingData.endDate"
          :showClearBtn="true"
          :setMinTime="true"
          :required="isEditing"
          :disabled="!isHoistingToSelectorEnabled || !isHoistingEndWindowSelectable"
          :highlightClass="!validEndDate ? 'error-highlight': ''"
          :disabledDateTimes="disabledEndDateTimes"
          :dirtyCheck="true"
          @updateDate="val => updateField('endDate',val)"
        />
        <span v-else>{{ formatDate(hoistingData.endDate, true) }}</span>
      </div>
    </div>
    <div class="hoistingDetail_isHotRequired">
      <p :class="['bold', {'required-flag': isEditing}]">
        {{ $t('workPermit.isHotTitle') }}
      </p>
      <div v-if="isEditing">
        <input
          :id="`hoistingDetail_isHotRequired_yes_${hoistingData.id}`"
          v-model="isHotWork"
          type="radio"
          :value="true"
          @click="_addHotWork"
        >
        <label :for="`hoistingDetail_isHotRequired_yes_${hoistingData.id}`">{{ $t('action.yes') }}</label>
        <input
          :id="`hoistingDetail_isHotRequired_no_${hoistingData.id}`"
          v-model="isHotWork"
          type="radio"
          :value="false"
          @click="_delHotWork"
        >
        <label :for="`hoistingDetail_isHotRequired_no_${hoistingData.id}`">{{ $t('action.no') }}</label>
      </div>
      <div v-else>
        <label>{{ isHotWork ? $t('action.yes') : $t('action.no') }}</label>
      </div>
    </div>
    <hr v-if="isHotWork">
    <div
      v-if="isHotWork"
      class="hotWorkDetails"
    >
      <p class="bold">
        {{ $t('workPermit.hotWorkDetails') }}
      </p>
      <ShowNotice
        :id="hoistingData.id"
        :title="$t('workPermit.noticeHotWork')"
        :noticeContent="NoticeHotWorkContent"
        :expand="expendHotWorkNotice"
      />
      <div class="hotWorkDetails_typeOfWork">
        <InputField
          :label="$t('workPermit.typeOfHotWork')"
          :readonly="!isEditing"
          :showFlag="isEditing"
          :showEmptyDash="true"
          :showColon="false"
          :value="getHotWorkField('type')"
          :required="true"
          @updateValue="val => updateHotWorkAttr('type', val)"
        />
      </div>
      <div class="hotWorkDetails_briefdescription">
        <InputField
          :label="$t('workPermit.briefDescriptionofWork')"
          :readonly="!isEditing"
          :showFlag="isEditing"
          :showEmptyDash="true"
          :showColon="false"
          :value="getHotWorkField('description')"
          :required="true"
          @updateValue="val => updateHotWorkAttr('description', val)"
        />
      </div>
      <div class="hotWorkDetails_equipmentused">
        <InputField
          :label="$t('workPermit.equipmentUsed')"
          :readonly="!isEditing"
          :showFlag="isEditing"
          :showEmptyDash="true"
          :showColon="false"
          :value="getHotWorkField('equipment')"
          :required="true"
          @updateValue="val => updateHotWorkAttr('equipment', val)"
        />
      </div>
    </div>
    <div class="hotWorkDetails_attachments">
      <p :class="['bold']">
        {{ $t('workPermit.attachment') }}
      </p>
      <HkldDropzone
        v-if="isEditing && canEditCurrentHoisting"
        :sourceId="sourceId"
      />
      <EditAttachments
        :sourceId="sourceId"
        :canDelete="isEditing && canEditCurrentHoisting"
        :canDownloadAll="false"
        :canEdit="isEditing && canEditCurrentHoisting"
        :getFilesList="getFilesList"
      />
      <div v-if="!isEditing && !filesLength">
        --
      </div>
    </div>
    <Modal
      ref="tooManyHoistingModal"
      :showCloseBtn="false"
    >
      <p class="tooManyHoistingModalMessage">
        {{ hoistingTooManyMessage }}
      </p>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--orange"
          @click="closeTooManyHoistingModal"
        >
          {{ $t('action.close') }}
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import dateUtil from '@/utils/dateUtil'
import DateTimeSelector from '@/controls/DateTimeSelector'
import EditAttachments from '@/controls/EditAttachments'
import HkldDropzone from '@/controls/HkldDropzone'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import Modal from '@/controls/Modal'
import mutationTypes from '@/store/mutation-types'
import InputField from '@/controls/InputField'
import ShowNotice from '@/controls/ShowNotice'
import EventBus from '@/utils/eventBus'
import { exportHoisting } from '@/api/printers/request'
import { getBuilding, formatFloors, floorsConsistent, getLastHistoryByStatusWithoutResume } from '@/api/workPermit/util'
import * as workPermitUtils from '@/api/workPermit/util'
import { getMaxWAPPRHoistingNum, isHoistingExceedMaxNum } from '@/api/workPermit/request'
import { getSubsidiaryTextArray } from '@/api/postman/util'
import { sendEmail } from '@/api/postman/request'
import { CONTRACTOR_TYPES } from '@/modules/tenantProjects/contractors/consts'
import { WORK_PERMIT_STATUS, DEFAULT_MAX_WAPPR_HOISTING_NUM } from '@/modules/workPermits/consts'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { timeOptions, EmailTypes } from '@/utils/consts'
import { utils as formUtils } from '@/plugin/InputChange'
import { getPhysicalSite } from '@/utils/siteUtils'
import {
  buildHoistingEndDisabledDateTimes,
  buildHoistingFromDisabledDateTimes,
  isHoistingEndDateValid,
  isHoistingEndWindowSelectable as hasHoistingEndWindowSelectable,
  isHoistingStartFullySelected,
  resolveHoistingEndDateOnFromChange,
} from './hoistingDuration.utils'
import { disableTenantContractorEdit, getHoistingExceedData, getParsedWorkPermitHistoryActor, getWorkPermitHistoryCreatedAt, isWorkPermitEditable, isStandaloneWpContractor, isStandaloneWpTenant, isStandaloneWpTenancyContractor } from './utils'
import { getDurationTitleLabel, getRegionalWorkPermitLabels, getTooManyHoistingMessage } from './regionalWorkPermitLabels'

export default {
  name: 'HoistingDetail',
  components: {
    DateTimeSelector,
    HKLSelect,
    InputField,
    EditAttachments,
    HkldDropzone,
    ShowNotice,
    Modal,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isProjectAvailable: {
      type: Boolean,
      default: false,
    },
    hoistingData: {
      type: [String, Object],
      default: '',
    },
    floorsOptions: {
      type: Array,
      default: () => [],
    },
    showOperate: {
      type: Boolean,
      default: false,
    },
    showPrint: {
      type: Boolean,
      default: false,
    },
    isPPSuspened: {
      type: Boolean,
      default: false,
    },
    operationCb: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      formatFloors,
      timeOptions: lodash.cloneDeep(timeOptions).slice(1),
      yesterday: new Date((new Date()).getTime() - dateUtil.ONE_DAY_MILLI),
      filesLength: 0,
      timestamp: new Date(),
      isEditing: this.isEdit,
      selfKey: (new Date()).getTime() + Math.ceil(Math.random() * 1000),
      validFloor: true,
      validStartDate: true,
      validEndDate: true,
      maxWAPPRHoistingNum: DEFAULT_MAX_WAPPR_HOISTING_NUM,
      WORK_PERMIT_STATUS,
    }
  },
  watch: {
    isEdit (val) {
      // if there's no buttons, that means isEditing is controlled by parent component
      // TODO: Merge isEdit & isEditing Rango_Yuan@epam.com
      if (!this.showOperate) this.isEditing = val
    },
  },
  computed: {
    sourceId () {
      return this.hoistingData.id
    },
    ...mapGetters('user', ['currentUser', 'isTenant', 'isEngineer', 'buildings']),
    ...mapGetters('workPermit', ['currentWorkPermit', 'parentPermit', 'buildingFloorZoneMap', 'workPermitsInProject']),
    ...mapGetters('projectContractors', ['currentMainContractor', 'isCurrentVendorAccount', 'myContractor']),
    ...mapGetters('tenantProject', ['currentTenantProject', 'isWithdrawn']),
    ...mapGetters('projects', ['currentProject']),
    ...mapGetters('regions', ['regionName']),
    NoticeHotWorkContent () {
      return this.$t(`termsAndConditions.${this.regionName}.NoticeHotWorkContent`)
    },
    durationTitleLabel () {
      return getDurationTitleLabel()
    },
    workPermitLabels () {
      return getRegionalWorkPermitLabels()
    },
    hoistingTooManyMessage () {
      return getTooManyHoistingMessage(
        this.maxWAPPRHoistingNum,
        this.hoistingData.standalone ? this.$t('workPermit.HoistingLimitHintType.work') : this.$t('workPermit.HoistingLimitHintType.project'),
      )
    },
    parent () {
      return this.currentWorkPermit
    },
    showEditBtn () {
      if (!this.isProjectAvailable) return false
      if (this.isWithdrawn) return false

      return this.canEditCurrentHoisting && (
        this.hoistingData.status === WORK_PERMIT_STATUS.DRAFT || (
          this.hoistingData.status === WORK_PERMIT_STATUS.REJECTED &&
          this.currentWorkPermit.status !== WORK_PERMIT_STATUS.REJECTED
        )
      )
    },
    canEditCurrentHoisting () {
      if (this.currentWorkPermit.standalone) {
        if (!this.currentWorkPermit.isTenantProject) {
          return isStandaloneWpContractor(this.currentWorkPermit)
        }
        return isStandaloneWpTenant(this.currentWorkPermit, this.currentUser) || isStandaloneWpTenancyContractor(this.currentWorkPermit, this.currentUser)
      } else {
        const contractorId = this.hoistingData.contractorId
        return (contractorId === this.myContractor.companyId && !disableTenantContractorEdit()) ||
          (this.isCurrentVendorAccount && contractorId === this.currentUser.externalId)
      }
    },
    parentPermitEditable () {
      return isWorkPermitEditable(this.currentWorkPermit)
    },
    isWaitingApprove () {
      return this.hoistingData.status === WORK_PERMIT_STATUS.REVIEWED
    },
    personIncharge () {
      return lodash.get(this.hoistingData, 'manager.displayName', null)
    },
    hoistingContractorInfo () {
      return lodash.get(this.hoistingData, 'contractor') || lodash.get(this.currentWorkPermit, 'contractor')
    },
    floorVal () {
      return lodash.get(this.hoistingData, 'floors', [])[0]
    },
    floorHklOptions () {
      return (this.floorsOptions || []).map((opt) => {
        const label = typeof opt === 'string' ? opt : (opt.label != null ? opt.label : opt)
        return { name: String(label), value: label }
      })
    },
    submitByInfo () {
      const histories = lodash.get(this.hoistingData, 'histories', [])
      const submitHistory = getLastHistoryByStatusWithoutResume(histories, WORK_PERMIT_STATUS.WAPPR)
      const actor = getParsedWorkPermitHistoryActor(submitHistory)
      const createdAt = getWorkPermitHistoryCreatedAt(submitHistory)
      const info = {}
      if (actor && actor.displayName && createdAt) {
        info.who = actor.displayName
        info.when = this.formatDate(createdAt)
      }
      return info
    },
    currentBuilding () {
      if (this.hoistingData.isTenantProject) {
        return this.hoistingData.standalone
          ? lodash.get(this.currentWorkPermit, 'tenancy.building.code')
          : lodash.get(this.currentTenantProject, 'tenancy.building.code') ||
            lodash.get(this.currentWorkPermit, 'project.tenancy.building.code')
      } else {
        return lodash.get(this.currentWorkPermit, 'building.code')
      }
    },
    disabledFromDates () {
      return buildHoistingFromDisabledDateTimes({
        yesterday: this.yesterday,
        wpStartDate: lodash.get(this.currentWorkPermit, 'startDate', ''),
        wpEndDate: lodash.get(this.currentWorkPermit, 'endDate', ''),
      })
    },
    disabledEndDateTimes () {
      return buildHoistingEndDisabledDateTimes({
        startDate: this.hoistingData.startDate,
        wpStartDate: lodash.get(this.currentWorkPermit, 'startDate'),
        wpEndDate: lodash.get(this.currentWorkPermit, 'endDate'),
      })
    },
    isHoistingToSelectorEnabled () {
      return isHoistingStartFullySelected(this.hoistingData.startDate)
    },
    isHoistingEndWindowSelectable () {
      return hasHoistingEndWindowSelectable({
        startDate: this.hoistingData.startDate,
        wpStartDate: lodash.get(this.currentWorkPermit, 'startDate'),
        wpEndDate: lodash.get(this.currentWorkPermit, 'endDate'),
      })
    },
    buildingFullName () {
      return lodash.get(this.buildingFloorZoneMap, this.currentBuilding, {}).fullName
    },
    isPermitRejected () {
      return lodash.get(this.currentWorkPermit, 'status') === WORK_PERMIT_STATUS.REJECTED
    },
    isSubmitDisable () {
      return this.isPPSuspened || this.isPermitRejected || !this.isProjectAvailable
    },
    isHotWork () {
      return !lodash.isEmpty(lodash.get(this, 'hoistingData.hotWork')) || false
    },
    expendHotWorkNotice () {
      return this.isHotWork && this.isEditing
    },
  },
  methods: {
    ...mapMutations('workPermit', {
      updateHoisting: mutationTypes.WORKPERMIT_SET_HOISTING_ATTRIBUTE,
      addHotWork: mutationTypes.WORKPERMIT_ADD_HOT_WORK,
      deleteHotWork: mutationTypes.WORKPERMIT_DELETE_HOT_WORK,
      updateHotWork: mutationTypes.WORKPERMIT_SET_HOT_WORK_INFO,
    }),
    ...mapActions('workPermit', ['updateHoistingById', 'submitHoisting', 'getWorkPermitById']),
    getFloor () {
      return this.hoistingData && formatFloors(this.hoistingData, this.currentBuilding, this.buildingFloorZoneMap)
    },
    updateField (name, value) {
      this.updateHoisting({
        id: this.hoistingData.id,
        name,
        value,
      })
    },
    onHoistingStartDateChange (startDate) {
      this.updateField('startDate', startDate)
      const wpStartDate = lodash.get(this.currentWorkPermit, 'startDate')
      const wpEndDate = lodash.get(this.currentWorkPermit, 'endDate')
      const resolvedEndDate = resolveHoistingEndDateOnFromChange({
        startDate,
        endDate: this.hoistingData.endDate,
        wpStartDate,
        wpEndDate,
      })
      if (resolvedEndDate !== this.hoistingData.endDate) {
        this.updateField('endDate', resolvedEndDate)
      }
    },
    getHotWorkField (value) {
      return this.hoistingData.hotWork[value]
    },
    validateDuration () {
      return isHoistingEndDateValid({
        startDate: this.hoistingData.startDate,
        endDate: this.hoistingData.endDate,
        wpStartDate: lodash.get(this.currentWorkPermit, 'startDate'),
        wpEndDate: lodash.get(this.currentWorkPermit, 'endDate'),
      })
    },
    updateFloor (val, type) {
      this.updateField('floors', [val])
    },
    changeEditStatus () {
      this.isEditing = !this.isEditing
    },
    formatDate (date, showTime = true) {
      return date ? dateUtil.formatDate(date, showTime) : this.$t('emptyValue')
    },
    getFilesList (files) {
      this.filesLength = files.length
    },
    resetErrStatus () {
      this.validFloor = true
      this.validStartDate = true
      this.validEndDate = true
    },
    async onSave () {
      this.operationCb(this.hoistingData.id, true)
      this.changeEditStatus()
      await this.updateHoistingById({request: this.hoistingData, refresh: false})
      this.resetErrStatus()
      formUtils.resetDirty()
    },
    async submit () {
      if (!this.isPPSuspened && !this.isPermitRejected && this.validate()) {
        // check max 7 hoisting
        const buildingId = workPermitUtils.getAttrOfBuilding(this.currentWorkPermit, 'id')
        const contractorType = this.currentWorkPermit.contractorType || (this.isCurrentVendorAccount ? CONTRACTOR_TYPES.MAIN : this.myContractor.type)

        this.updateField('contractorType', contractorType)
        const hoistingInfo = getHoistingExceedData(this.currentWorkPermit, {[this.hoistingData.floors[0]]: 1}, contractorType, buildingId)
        const isHoistingCountValid = await isHoistingExceedMaxNum(hoistingInfo)
        if (!isHoistingCountValid) {
          this.maxWAPPRHoistingNum = await getMaxWAPPRHoistingNum()
          this.openTooManyHoistingModal()
          return
        }

        this.operationCb(this.hoistingData.id, true)
        this.changeEditStatus()
        const hoisting = await this.submitHoisting(this.hoistingData)
        this.resetErrStatus()
        formUtils.resetDirty()
        const isParentPermitApproved = this.currentWorkPermit && ![WORK_PERMIT_STATUS.DRAFT, WORK_PERMIT_STATUS.WAPPR, WORK_PERMIT_STATUS.ACKNOWLEDGED, WORK_PERMIT_STATUS.REVIEWED].includes(this.currentWorkPermit.status)
        if (isParentPermitApproved) {
          const hoistingTemplate = dateUtil.isWithinOfficeHours(hoisting.startDate, hoisting.endDate) ? EmailTypes.workPermits.applyHoisting : EmailTypes.workPermits.applyHoistingAfterOfficeHour
          await sendEmail(hoistingTemplate, {
            ...hoisting,
            location: this.parent.location,
            workType: this.parent.workType,
          })
        }
        await sendEmail(EmailTypes.workPermits.applyHoistingToContractor, {
          ...hoisting,
          location: this.parent.location,
          workType: this.parent.workType,
        })
      }
    },
    async cancel () {
      this.changeEditStatus()
      await this.getWorkPermitById(this.hoistingData.parentId, false)
      formUtils.resetDirty()
    },
    validate () {
      this.validStartDate = !!this.hoistingData.startDate && this.validateDuration()
      this.validEndDate = !!this.hoistingData.endDate && this.validateDuration()
      this.validFloor = !lodash.isEmpty(this.hoistingData.floors) && floorsConsistent(this.currentWorkPermit, this.hoistingData.floors)
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, `.hoistingDetail_${this.selfKey}`)
      return fusionInputCheckUtil.isAllFieldsValid(`.hoistingDetail_${this.selfKey}`) &&
        this.validStartDate && this.validEndDate && this.validFloor
    },
    _addHotWork () {
      this.addHotWork(this.hoistingData.id)
    },
    _delHotWork () {
      this.deleteHotWork(this.hoistingData.id)
    },
    updateHotWorkAttr (name, value) {
      this.updateHotWork({hoistingId: this.hoistingData.id, name, value})
    },
    getIsolatedDevicesRecommandation () {
      let result = null
      let textArr = lodash.get(this, '$parent.isolatedDevicesRecommendation')
      if (!lodash.isEmpty(textArr)) {
        result = textArr.map((text, i) => `<p>${i + 1}. ${text}</p>`).join('')
      }
      return result
    },
    async printHoisting () {
      const building = getBuilding(this.parent, false)
      const buildingInfo = this.buildingFloorZoneMap[building]
      const site = getPhysicalSite(buildingInfo.sites)
      const recommendations = this.getIsolatedDevicesRecommandation()
      const hoistingPdfInfo = {
        contractorName: lodash.get(this.hoistingData, 'contractor.name', this.$t('emptyValue')),
        duration: this.formatDate(this.hoistingData.startDate) + ' - ' + this.formatDate(this.hoistingData.endDate),
        code: this.hoistingData.code,
        building: buildingInfo.fullName || this.$t('emptyValue'),
        floors: formatFloors(this.hoistingData, this.currentBuilding, this.buildingFloorZoneMap),
        workArea: lodash.get(this.hoistingData, 'workArea', ''),
        isNoRecommendations: !recommendations,
        recommendations: recommendations,
        description: lodash.get(this.hoistingData, 'description'),
        subsidiaryArray: getSubsidiaryTextArray(site.subsidiary),
        isHotWork: this.isHotWork,
        workPermitLabels: this.workPermitLabels,
        options: {
          border: {bottom: '35mm'},
        },
      }
      this.pdfId = await exportHoisting(hoistingPdfInfo)
    },
    openTooManyHoistingModal () {
      this.$refs.tooManyHoistingModal.open()
    },
    closeTooManyHoistingModal () {
      this.$refs.tooManyHoistingModal.close()
    },
  },
  mounted () {
    EventBus.$on('edit_when_add_hoisting',
      id => id === this.hoistingData.id && this.isEditing === false && this.changeEditStatus())
  },
  destroyed () {
    EventBus.$off('edit_when_add_hoisting')
  },
}
</script>

<style lang='scss'>
@import "~styles/newMultiselect";
.hoistingDetail {
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 0;
  i.gray_font {
    font-size: 12px;
    color: #878787;
    height: 20px;
    display: block;
    margin: 5px 0;
  }
  .bold {
    font-weight: bold;
  }

  .hoistingDetail_operate {
    position: absolute;
    font-size: 0;
    right: 0;
    button {
      margin-right: 15px;
    }
  }
  .hoistingDetail_duration {
    .hoistingDetail_timePicker {
      display: flex;
      align-items: center;
      > .date-time-select {
        flex: 0 0 300px;
        max-width: 300px;
        width: 300px;
        html[lang='zh-CN'] & {
          flex-basis: 315px;
          max-width: 315px;
          width: 315px;
        }
      }
    }
    .hoistingDetail_timePickerTo {
      margin-right: 10px;
    }
  }
  .hoistingDetail_timePicker ::v-deep {
    .vdp-datepicker {
      vertical-align: bottom;
    }
    .date-time-select {
      display: inline-block;
      width: 300px;
      html[lang='zh-CN'] & {
        width: 315px;
      }
    }
    .vdp-datepicker, .hkl-select {
      display: inline-block;
    }
  }
  p {
    margin-bottom: 5px;
  }
  label {
    margin-top: 0 !important;
  }
  hr {
    margin: 15px auto;
  }
  .hoistingDetail_table,
  .hoistingDetail_workArea,
  .hoistingDetail_description,
  .hoistingDetail_duration,
  .hoistingDetail_isHotRequired,
  .hotWorkDetails_typeOfWork,
  .hotWorkDetails_briefdescription,
  .hotWorkDetails_equipmentused,
  .hotWorkDetails_safetyprecautions,
  .hotWorkDetails_attachments {
    margin-top: 15px;
  }
  .fusion-input-check-is-invalid-input {
    border-color: #b5b5b5 !important;
  }
  .hoistingDetail_duration .error-highlight input,
  .hoistingDetail_floor .error-highlight .multiselect__tags {
    background: #f9ecea;
  }
  .hoistingDetail_table {
    tr, td {
      border: none;
      margin: 0;
      padding: 0;
    }
    border: none !important;
    width: auto;
    height: 47px;
    border-spacing: 0 !important;
    margin-bottom: 0;
    .hoistingDetail_building {
      min-width: 200px;
      padding-right: 15px
    }
  }
  .hoistingDetail_table.isEditing {
    height: 70px;
  }
}
</style>

<style scoped>
  .tooManyHoistingModalMessage {
    font-weight: bold;
  }
</style>
